import React, { ComponentType } from 'react';

import styles from '../styles.module.css';
import PencilIcon from '@/assets/icons/pencil.svg?react';
import { AdminCardHeader } from '@/components/AdminToolComponents/card';
import { Button } from '@/components/Form/Button';

interface AdminDetailHeaderProps {
  title: string;
  icon: ComponentType<{ className?: string }>;
  isEditing?: boolean;
  onEditClick?: () => void;
  editButtonLabel?: string;
  right?: React.ReactNode;
}

export const AdminDetailHeader = ({
  title,
  icon: Icon,
  isEditing = false,
  onEditClick,
  editButtonLabel = 'EDIT',
  right
}: AdminDetailHeaderProps) => (
  <AdminCardHeader
    left={
      <>
        <Icon className={styles.adminIconHeader} />
        <h2 className={styles.adminTitle}>{title}</h2>
        {!isEditing && onEditClick && (
          <Button
            onClick={onEditClick}
            color="blue"
            solid={false}
            label={editButtonLabel}
            icon={PencilIcon}
            iconPosition="left"
          />
        )}
      </>
    }
    right={right}
  />
);
